<template lang="pug">
.inset
  channelAds
  .channel-home.inset(v-nv:scope="'channel-home'", @nv-numpad="$channelSelectWithNumber")
    .channel-home-item.h-100(
      v-nv,
      @nv-enter="choose",
      @nv-ch_down="commitSection('osd', 'down')",
      @nv-ch_up="commitSection('osd', 'up')",
      @nv-up="commitSection('osd')",
      @nv-down="commitSection('osd')",
      @nv-list="commitSection('list')",
      @nv-info="commitSection('osd')",
      @nv-back="goBack"
    )
      pr-wrapper.p-5(fs, bg="darken", v-if="channel && channel.price && !channel.owned")
        .col.col-6.offset-3.text-center
          img.my-5(src="@/assets/images/lock_channel.gif", style="width: 200px")
          pr-text.mb-5(size="medium") {{ $t("channelNeed2Buy", [channel.title, channel.price.group]) }}
          pr-button.themed.mr-3
            | Buy
            span.ml-1 - {{ $currency(channel.price.value) }}
      .radio-wrapper(v-show="isRadio")
        icon.music.p-2.d-block.fa-3x(:icon="'fas music'")
        img(src="@/assets/images/radio.gif")

  channelSidebar(v-visible="channelList && !single")
  channelCategories(v-visible="channelList && !single", @section="commitSection($event)", :activeSection="section")
  channelList(v-visible="channelList", @section="commitSection($event)")
  channelOsd(v-visible="channelOsd", @section="commitSection($event)")
</template>

<script>
import channelCategories from "./channel-categories"
import channelSidebar from "./channel-sidebar"
import channelList from "./channel-list"
import channelOsd from "./channel-osd"
import channelAds from "./channel-ads"
import { mapGetters } from "vuex"
export default {
  name: "live",
  components: { channelCategories, channelList, channelOsd, channelSidebar, channelAds },
  data() {
    return {
      section: null,
      initialized: false,
      channelUpdateTimeout: null
    }
  },
  computed: {
    isRadio() {
      return this.category === "Radio" || this.channel?.groups.includes("Radio")
    },
    category: {
      get: () => this_.$store.state.live.category,
      set: value => this_.$store.commit("live/category", value)
    },
    single: {
      get: () => this_.$store.state.live.single,
      set: value => this_.$store.commit("live/single", value)
    },
    channelList() {
      return ["list", "categories"].includes(this.section)
    },
    channelOsd() {
      return this.section === "osd"
    },
    channelAds() {
      return !this.section
    },
    ...mapGetters("live", ["defaultChannel", "firstChannel", "channel", "channels", "categories"])
  },
  watch: {
    channel(nval, oval) {
      if (this._inactive || !this.initialized) return
      if (oval) oval.subtitle = null

      if (!nval) return

      this.play(nval)

      if (this.channelUpdateTimeout) _$.removeTimeout(this.channelUpdateTimeout)
      const payload = { mac: __.device.get("mac"), last_tuned_channel_id: nval.id }
      this.channelUpdateTimeout = _$.makeTimeout(() => __.api.set.updateDeviceProperty(payload), 5000)
    },
    section(nval) {
      if (this._inactive) return

      if (nval === "list") _$.nav.changeScope("channel-list")
      else if (!this.single && nval === "categories") _$.nav.changeScope("channel-categories")
      else if (nval === "osd") _$.nav.changeScope("channel-osd")
      else _$.nav.changeScope("channel-home")
    }
  },
  async deactivated() {
    _$.vue.$off("sleep", this.scopeChecker)
    this.commitSection(null)
    this.initialized = false
  },
  async activated() {
    await this.hasInitialCategory()

    _$.vue.$on("sleep", this.scopeChecker)

    this.play(this.channel)
    await this.$nextTick()

    this.commitSection(this.$route.params.scope || "list")
  },
  async mounted() {
    _$.nav.sync("channel-home")
  },
  methods: {
    commitSection(section, channelChange) {
      if (channelChange) _$.vue.$emit("changeChannel", { detail: { value: `ch_${channelChange}`, instant: true } })
      else this.section = section
    },
    async choose() {
      if (this.channel.price && !this.channel.owned) {
        const res = await __.order.add({
          title: this.channel.price.group,
          count: 1,
          id: this.channel.id,
          price: this.channel.price.value,
          main: this.channel.price.group,
          endpoint: __.device.config("PAYTV_ENDPOINT"),
          action_type: "channel"
        })
        if (!res) return

        await this.$store.dispatch("services/fetchOrders")
        await this.$nextTick()
        if (this.channel.owned) return this.play(this.channel).then(() => _$.vue.$emit("channel-guide", this.channel))
      }

      this.commitSection("list")
    },
    goBack() {
      if (this.channel.price && !this.channel.owned) return this.commitSection("list")
      else this.goHome()
    },

    async play(channel) {
      if (!channel) return
      if (channel.price && !channel.owned) return __.media.destroy()
      if (channel.pin) {
        const res = await __.media.pinCodeMiddleware(channel)
        if (!res) return false
      }

      let address = channel.channel_uri?.trim()
      if (["playmore", "playmoreatv", "playmoregtv"].includes(__.device.properties.type)) address = channel.channel_free_uri?.trim() || address

      return __.media.play(address, true, channel)
    },
    scopeChecker() {
      if (_$.nav.currentScopeName("channel-osd")) this.commitSection(null)
    },
    async hasInitialCategory() {
      this.category = this.categories.find(item => item.toLowerCase() === this.$route.params.category) || null
      this.single = this.category ? true : false

      const useLastChannel = _$.true(__.device.config("last_channel_startup.last_channel_startup"))

      if (useLastChannel && this.lastChannel) {
        this.$store.commit("live/channel", this.lastChannel)
      } else {
        this.$store.commit(
          "live/channel",
          this.single ? this.firstChannel : this.channels.includes(this.channel) ? this.channel : this.defaultChannel
        )
      }

      await this.$nextTick()
      this.initialized = true
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-sidebar {
  width: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0rem 0rem 1rem rgba(0, 0, 0, 50%) !important;

  .channel-sidebar-item {
    width: 40px;
    margin: 10px 0;
    height: 40px;
    position: relative;

    .csi-container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
    }
  }
}

.channel-list.pushed {
  left: 460px;
}

.channel-list.single {
  left: 0 !important;
}
.radio-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  background: black;

  .music,
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .music {
    z-index: 2;
  }
}
</style>
